module.exports = __webpack_public_path__ + "media/images/favicons/favicon-5031ac74dc285848117d4dff60031a85.ico";